import { showBadge, sumCounts, type CustReqCounts } from '@indipia/shared-features'

// 스케줄 교체·삭제 확인창의 고객 요청 안내 문구 — 순수 함수(렌더·API 없음).
// 기존 공종 삭제 안내(buildTaskDeleteConfirm)와 같은 규칙: 건수 1 이상이면 건수 문구, 집계 null 이면 건수 없는 문구, 0건이면 안내 없음. 삭제는 막지 않는다.

export type ScheduleNoticeMode = 'replace' | 'delete'

/** 스케줄 공종들의 요청 건수 합계 — 모두 null(집계 실패)이면 null, 공종이 없으면 0 */
export function sumScheduleRequestCount(tasks: readonly CustReqCounts[] | null | undefined): number | null {
  if (!tasks) return null
  if (tasks.length === 0) return 0
  return sumCounts(tasks).requestCount
}

/** 안내 문구 — 0건이면 null(안내를 덧붙이지 않음), null·미확인이면 건수 없는 문구 */
export function buildScheduleReplaceNotice(opts: { mode: ScheduleNoticeMode; requestCount: number | null | undefined }): string | null {
  const { requestCount } = opts
  if (typeof requestCount === 'number' && Number.isFinite(requestCount) && requestCount <= 0) return null
  const verb = opts.mode === 'replace' ? '교체' : '삭제'
  const subject = showBadge(requestCount) ? `고객 요청 ${requestCount}건이` : '고객 요청이'
  return `스케줄을 ${verb}하면 기존 공종이 모두 삭제되어 ${subject} 사장님 화면에서 보이지 않게 됩니다. 이미 반장에게 전달된 요청은 반장 화면에는 남습니다. 같은 이름의 공종이 새로 만들어져도 이어지지 않습니다.`
}
